import { render, staticRenderFns } from "./kehuxinxibiangeng.vue?vue&type=template&id=f461e534&scoped=true&"
import script from "./kehuxinxibiangeng.vue?vue&type=script&lang=js&"
export * from "./kehuxinxibiangeng.vue?vue&type=script&lang=js&"
import style0 from "./kehuxinxibiangeng.vue?vue&type=style&index=0&id=f461e534&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f461e534",
  null
  
)

export default component.exports